import React, {useEffect, useState, useContext} from "react";

import {azureTokenContext, userInfoContext} from "../../App";

import * as ApiCalls from "./ApiCalls";

import "../../style/unresolvedValidationsBox.css";

import moment from "moment";
import "moment/locale/nb";

export default function UnresolvedValidationsBox() {
    const [unresolvedValidations, setUnresolvedValidations] = useState<any>([]);
    const [userInfo] = useContext(userInfoContext);
    const azureToken = useContext(azureTokenContext);

    useEffect(() => {
        async function fetchUnresolvedValidations() {
            if (userInfo.Id) {
                await checkUnresolvedValidation();
            }
        }

        fetchUnresolvedValidations();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userInfo.Id]);

    const checkUnresolvedValidation = async () => {
        await ApiCalls.getUnresolvedValidations(userInfo, azureToken)
            .then((res) => {
                setUnresolvedValidations(res);
            })
            .catch((e) => {
                ApiCalls.log("ERROR", "Failed GetUnresolvedValidation " + e.message, "AuthorsPortal", "", "", userInfo?.Id, azureToken);
            });
    };

    return (
        <>
            {unresolvedValidations.length !== 0 && (
                <div className="validation-box">
                    <strong>
                        Dine endringer er
                        registrert {moment(unresolvedValidations[0].CreatedUtc).format("DD.MM.YYYY")} og vil bli
                        oppdatert i
                        løpet av en uke.
                    </strong>
                </div>
            )}
        </>
    );
}
